import { EGarageStatus } from '../../../../json_query';
import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IGarageStatusesTagType = 'advanced-garageStatus';

export interface IGarageStatusesTag {
  type: 'advanced-garageStatus';
  value: EGarageStatus;
}

const isGarageStatusesTag = (tag: TTag): tag is IGarageStatusesTag => tag.type === IGarageStatusesTagType;

export const garageStatusesTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.garage_status && jsonQuery.garage_status.value;

    let nextTags = tags.filter(
      tag => tag.type !== IGarageStatusesTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EGarageStatus) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IGarageStatusesTag => isGarageStatusesTag(tag) && tag.value === value,
            () => ({ type: IGarageStatusesTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
